import Axios from 'axios';
import React, { useCallback, useEffect, useState } from 'react';
import { Button, Input, message, Space, Table, Tag } from 'antd';
import {
  EditOutlined,
  PlusOutlined,
  ReloadOutlined,
  SearchOutlined,
} from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import {
  PageContainer,
  PageHeader,
  textSorter,
} from '../../common';

const SurveyGuideMgrPage = () => {
  const history = useHistory();
  const [guides, setGuides] = useState([]);
  const [loading, setLoading] = useState(false);
  const [keyword, setKeyword] = useState('');

  const executorToken =
    (typeof window !== 'undefined' && localStorage.getItem('w_auth')) || '';

  const fetchGuides = useCallback(async () => {
    setLoading(true);
    try {
      const res = await Axios.get('/api/surveyGuide', {
        headers: { 'x-user-token': executorToken },
        params: { keyword: keyword || undefined },
      });
      if (res.data && res.data.success) {
        setGuides(res.data.guides || []);
      } else {
        message.error('回答案内の取得に失敗しました');
      }
    } catch (error) {
      console.error(error);
      message.error('回答案内の取得に失敗しました');
    } finally {
      setLoading(false);
    }
  }, [executorToken, keyword]);

  useEffect(() => {
    fetchGuides();
  }, [fetchGuides]);

  const columns = [
    {
      title: 'サーベイコード',
      dataIndex: 'survey_code',
      width: 120,
      sorter: textSorter('survey_code'),
    },
    {
      title: 'タイトル',
      dataIndex: 'title',
      width: 260,
      ellipsis: true,
      sorter: textSorter('title'),
    },
    {
      title: 'guide_key',
      dataIndex: 'guide_key',
      width: 220,
      ellipsis: true,
      sorter: textSorter('guide_key'),
    },
    {
      title: '条件',
      key: 'condition',
      width: 260,
      render: (_, record) => (
        <Space size={[4, 4]} wrap>
          <Tag>{record.type_360 || 'all'}</Tag>
          <Tag>{record.relation_scope || 'all'}</Tag>
          <Tag>{record.sub_type || 'all'}</Tag>
          <Tag>{record.variant_key || 'default'}</Tag>
        </Space>
      ),
    },
    {
      title: '優先度',
      dataIndex: 'priority',
      width: 90,
      sorter: (a, b) => (a.priority || 0) - (b.priority || 0),
    },
    {
      title: '操作',
      key: 'action',
      width: 110,
      render: (_, record) => (
        <Button
          icon={<EditOutlined />}
          onClick={() => history.push(`/surveyguide/${record._id}/edit`)}
        >
          編集
        </Button>
      ),
    },
  ];

  return (
    <PageContainer fluid>
      <PageHeader
        title="回答案内管理"
        subtitle="サーベイ回答前に表示する案内文を管理します。"
        extra={
          <Space align="center">
            <Input
              allowClear
              placeholder="タイトル / guide_key"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              onPressEnter={fetchGuides}
              style={{ width: 260 }}
            />
            <Button icon={<SearchOutlined />} onClick={fetchGuides}>
              検索
            </Button>
            <Button icon={<ReloadOutlined />} onClick={fetchGuides}>
              更新
            </Button>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => history.push('/surveyguide/new')}
            >
              新規作成
            </Button>
          </Space>
        }
      />
      <Table
        rowKey="_id"
        loading={loading}
        dataSource={guides}
        columns={columns}
        pagination={{ pageSize: 20 }}
      />
    </PageContainer>
  );
};

export default SurveyGuideMgrPage;
